// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"12":"profiler","777":"recorder"}[chunkId] + "-" + {"12":"d791ace5c5ca570117ae","777":"91997b2b19881c987375"}[chunkId] + ".js";
};